import styled from "styled-components";
import { theme, glassCardStyles, typography } from "../styles";

export const AnalystSection = styled.section`
  position: relative;
  padding: 48px 16px 64px;
  border-top: 1px solid hsl(var(--hp-border) / 0.4);
  background: ${theme.secondarySofter};

  @media (min-width: 768px) {
    padding: 64px 24px 96px;
  }
`;

export const AnalystHeader = styled.div`
  max-width: 672px;
  margin: 0 auto 40px;
  text-align: center;

  @media (min-width: 768px) {
    margin-bottom: 64px;
  }
`;

export const AnalystTitle = styled.h2`
  margin: 0 0 16px;
  color: ${theme.foreground};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: ${typography.weights.extrabold};
  line-height: 1.15;

  span {
    background-image: ${theme.gradientGold};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const AnalystLead = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: clamp(1.0625rem, 2vw, 1.25rem);
  line-height: 1.55;
`;

export const AnalystGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  max-width: 1280px;
  margin: 0 auto 40px;

  @media (min-width: 640px) {
    gap: 24px;
    margin-bottom: 64px;
  }
`;

export const AnalystCard = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
  padding: 20px;
  border-radius: 16px;
  text-align: center;
  ${glassCardStyles}
  transition: border-color 0.3s ease, transform 0.3s ease;

  &:hover {
    border-color: hsl(32 95% 55% / 0.3);
  }

  @media (min-width: 640px) {
    width: calc(50% - 12px);
    padding: 24px;
  }

  @media (min-width: 1024px) {
    width: calc(33.333% - 16px);
  }

  @media (min-width: 1280px) {
    width: calc(25% - 18px);
  }
`;

export const AnalystCardBody = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 0;
  text-align: center;
`;

export const AvatarWrap = styled.div`
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  margin: 0 auto 16px;
  overflow: hidden;
  border-radius: 50%;
  background: ${theme.muted};
  box-shadow: 0 0 0 2px hsl(32 95% 55% / 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  ${AnalystCard}:hover & {
    transform: scale(1.05);
    box-shadow: 0 0 0 2px hsl(32 95% 55% / 0.6);
  }
`;

export const AnalystAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const AnalystName = styled.h3`
  margin: 0 0 4px;
  color: ${theme.foreground};
  font-size: 1.125rem;
  font-weight: 700;
`;

export const AnalystRole = styled.p`
  margin: 0 0 12px;
  color: ${theme.primary};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.4;
`;

export const AnalystBio = styled.p`
  margin: 0;
  flex: 1 1 auto;
  width: 100%;
  padding-bottom: 16px;
  color: ${theme.textMuted};
  font-size: 0.875rem;
  line-height: 1.625;
`;

export const AnalystSpecialty = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: auto;
  padding: 4px 12px;
  border-radius: 999px;
  background: ${theme.muted};
  color: ${theme.textMuted};
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const MidCtaWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 4px;
`;

export const AnalystCta = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 28rem;
  min-height: 52px;
  padding: 0 24px;
  border: none;
  border-radius: ${theme.radiusLg};
  background-image: ${theme.gradientGold};
  box-shadow: ${theme.shadowButton};
  color: ${theme.primaryForeground};
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 30px hsl(32 95% 55% / 0.5);
  }

  @media (min-width: 640px) {
    width: auto;
    max-width: none;
    min-height: 56px;
    padding: 0 40px;
    font-size: 1.125rem;
  }
`;
